import { ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants } from '@festina/datamart-general-types/datamart/hooks/ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants'

export const useFetchDatamartTenantsNoSuspense =
  ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants.useQuery
